<form [formGroup]="vacancyForm" class="p-fluid grid">
  <div class="field grid">

    <div class="col-12 md:col-6 field">
      <label for="code" class="block mb-2 font-medium">{{ 'VACANCY-CODE' | translate }}</label>
      <input pInputText
        id="code"
        formControlName="code"
        class="w-full"
        maxlength="5">
    
      
    </div>

    <div class="col-12 md:col-6 field">
      <label for="movementLocation" class="block mb-2 font-medium">{{ 'LOCAL' | translate }}</label>
      <p-dropdown
        id="movementLocation"
        formControlName="movementLocation"
        [options]="movementLocations"
        optionLabel="name"
        placeholder="Selecione o local"
        [showClear]="true"
        class="w-full">
      </p-dropdown>
    </div>

    <div class="col-12 md:col-4 field">
      <label for="width" class="block mb-2 font-medium">Tam. Máximo (pés)</label>
      <p-inputNumber
        id="width"
        formControlName="maxBoatLength"
        [min]="0"
        mode="decimal"
        [showButtons]="true"
        class="w-full">
      </p-inputNumber>
    </div>


    <div class="col-12 md:col-4 field">
      <label for="width" class="block mb-2 font-medium">{{ 'VACANCY-WIDTH' | translate }}</label>
      <p-inputNumber
        id="width"
        formControlName="berthMapWidth"
        [min]="0"
        mode="decimal"
        [showButtons]="true"
        class="w-full">
      </p-inputNumber>
    </div>

    <div class="col-12 md:col-4 field">
      <label for="length" class="block mb-2 font-medium">{{ 'VACANCY-LENGTH' | translate }}</label>
      <p-inputNumber
        id="length"
        formControlName="berthMapHeight"
        [min]="0"
        mode="decimal"
        [showButtons]="true"
        class="w-full">
      </p-inputNumber>
    </div>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-4">

    <button class="easymarine primary" type="button" [disabled]="!vacancyForm.valid" (click)="save()">{{ 'SAVE' | translate }}</button>

  </div>
</form>